import { useEffect, useState } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { TabMenu } from "primereact/tabmenu";
import PageContainer from "../../Components/Page/PageContainer";
import { ROUTES } from "../../config/routes";
import { BannerDashboardPageShell } from "./bannerDashboardLayout";

const TAB_ROUTES = [
  ROUTES.BANNER_DASHBOARD_DEFAULT_BANNERS,
  ROUTES.BANNER_DASHBOARD_SWAP_QUEUE,
  ROUTES.BANNER_DASHBOARD_CALENDAR,
] as const;

const TAB_ITEMS = [
  { label: "Default banners", icon: "pi pi-images" },
  { label: "Swap queue", icon: "pi pi-list" },
  { label: "Calendar", icon: "pi pi-calendar" },
];

const getActiveTabIndex = (pathname: string) => {
  if (pathname.includes("/calendar")) return 2;
  if (pathname.includes("/swap_queue")) return 1;
  return 0;
};

const BannerDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(() =>
    getActiveTabIndex(location.pathname)
  );

  useEffect(() => {
    setActiveIndex(getActiveTabIndex(location.pathname));
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname === ROUTES.BANNER_DASHBOARD) {
      navigate(ROUTES.BANNER_DASHBOARD_DEFAULT_BANNERS, { replace: true });
    }
  }, [location.pathname, navigate]);

  const handleTabChange = (e: { index: number }) => {
    setActiveIndex(e.index);
    navigate(
      TAB_ROUTES[e.index] ?? ROUTES.BANNER_DASHBOARD_DEFAULT_BANNERS
    );
  };

  return (
    <PageContainer
      HomeMenuBarprops={{
        title: "Banner Dashboard",
        Tabs: (
          <TabMenu
            activeIndex={activeIndex}
            onTabChange={handleTabChange}
            model={TAB_ITEMS}
          />
        ),
      }}
    >
      <BannerDashboardPageShell>
        <Outlet />
      </BannerDashboardPageShell>
    </PageContainer>
  );
};

export default BannerDashboard;
